import * as $ from 'jquery';
import { SurveyPageMultipleApplication } from './SurveyPageMultipleApplication';

$(() => {
    const surveyPageMultiple = $('[data-survey-page-multiple]');
    // If we are not on companyPaying page we stop script
    if (surveyPageMultiple.length === 0) {
        return;
    }

    let container = $(surveyPageMultiple[0]);
    container.data('surveyPageApp', new SurveyPageMultipleApplication(container));
});
